



















































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { listMixin } from "@/mixins/listMixin";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import {
  GetStudentsList,
  ImportStudent,
  Delstudents,
  EditStudent,
  DelTeacher,
  ResetPassword,
} from "@/request/common";

// 声明electron全局变量
declare global {
  interface Window {
    electron?: boolean;
    require?: any;
  }
}

@Component({
  components: {
    Header,
    LeftNav,
  },
})
export default class Name extends mixins(listMixin) {
  private query: any = {};
  private data: any = [];
  private file: any = {};
  private ifShowEdit: any = false;
  private editData: any = {};
  private ifShowImport: any = false;
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private banApply(item: any) {
    const type: any = item["状态"] == "禁用" ? "启用" : "禁用";
    this.$confirm("您确定要" + type + "该账号么？", type, {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      item["状态"] = item["状态"] == "禁用" ? "正常" : "禁用";
      item.banji_id = item["所属班级"].banji_id;
      EditStudent(this, item, loading)
        .then((res: any) => {
          loading.close();
          this.$message.warning(type + "成功");
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private resetPaw(item: any) {
    this.$confirm("您确定要重置密码么？", "重置密码", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        user_id: item.user_id,
      };
      ResetPassword(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("重置密码成功");
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private deleteOne(item: any) {
    this.$confirm("您确定要删除该数据么？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    })
      .then(() => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        const params: any = {
          data: {
            user_id: item.user_id,
          },
        };
        DelTeacher(this, params, loading)
          .then((res: any) => {
            loading.close();
            this.$message.success("删除成功");
            if (this.data.length === 1 && this.filters.current_page !== 1) {
              this.filters.current_page--;
            }
            this.getList();
          })
          .catch(() => {
            loading.close();
            this.$message.success("删除成功");
            this.getList();
          });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  private addSure() {
    if (!this.editData["姓名"]) {
      this.$message.warning("请输入学生姓名");
      return;
    }
    if (!this.editData["账户名"]) {
      this.$message.warning("请输入学号");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    EditStudent(this, this.editData, loading)
      .then((res: any) => {
        loading.close();
        if (this.editData.user_id) {
          this.$message.success("编辑成功");
        } else {
          this.$message.success("添加成功");
        }
        this.ifShowEdit = false;
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  private openEdit(item: any) {
    if (item) {
      this.editData = JSON.parse(JSON.stringify(item));
      this.editData.banji_id = this.editData["所属班级"].banji_id;
    } else {
      this.editData = {
        banji_id: this.query.banji_id,
        状态: "正常",
      };
    }
    this.ifShowEdit = true;
  }
  private delAll() {
    if (this.selectedMessages.length == 0) {
      this.$message.warning("请选择需要删除的数据");
      return;
    }
    this.$confirm("您确定要删除所选数据么？", "批量删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    }).then(() => {
      let ids: any = [];
      this.selectedMessages.forEach((ele: any) => {
        ids.push(ele.user_id);
      });

      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        data: {
          ids: ids,
        },
      };
      Delstudents(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("批量删除成功");
          this.selectedMessages = [];
          if (this.data.length === 1 && this.filters.current_page !== 1) {
            this.filters.current_page--;
          }
          this.getList();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private openImport() {
    this.file = {};
    this.ifShowImport = true;
  }
  private upload(file: any, item?: any) {
    this.file = file;
  }
  private uploadSure() {
    const fileObj = this.file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("teacher_id", this.$store.state.user.user_id);
    form.append("banji_id", this.query.banji_id);
    form.append("file", fileObj);
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    ImportStudent(this, form, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("批量导入成功");
        this.ifShowImport = false;
        this.getList();
      })
      .catch(() => {
        loading.close();
      });
  }
  private async download() {
    try {
      const url = `https://cjweb.oss-cn-shanghai.aliyuncs.com/jx/student_template.xlsx?t=${Date.now()}`;
      
      if (this.systemInfo.SETTING.ifDesktop) {
        // 桌面端使用electron下载
        const loading = this.$loading({
          lock: true,
          text: "下载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        
        const result = await window.electronMyAPI.downloadFile(url);
        
        loading.close();
        if (result.success) {
          this.$message.success('下载成功');
        } else {
          this.$message.error(result.message || '下载失败');
        }
      } else {
        // 网页端直接打开下载
        window.open(url);
      }
    } catch (error) {
      console.error('下载失败:', error);
      this.$message.error('下载失败，请重试');
    }
  }
  getList() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      search: this.filters.search,
      banji_id: this.query.banji_id,
      order_key: this.filters.sort_field,
      order_value: this.filters.sort_value,
      current_page: this.filters.current_page,
      page_count: this.filters.page_count,
    };
    localStorage.setItem(
      "classStudentListFilter",
      JSON.stringify(this.filters)
    );
    GetStudentsList(this, params, loading)
      .then((res: any) => {
        loading.close();
        res.data.forEach((element: any) => {
          const inc = this.selectedMessages.findIndex((i: any) => {
            return i["user_id"] === element["user_id"];
          });
          if (inc !== -1) {
            element["selected"] = true;
          } else {
            element["selected"] = false;
          }
        });
        this.data = res.data;
        this.filters.total_count = res.total_count;
        this.filters.total_page = res.total_page;
        if (this.data.length > 0) {
          this.ifShowEmpty = false;
        } else {
          this.ifShowEmpty = true;
        }
      })
      .catch(() => {
        loading.close();
      });
  }
  mounted() {
    this.filters.sort_field = "update_time";
    if (this.$route.query.data) {
      this.query = JSON.parse(this.$route.query.data as any);
    }
    if (localStorage.getItem("classStudentListFilter")) {
      this.filters = JSON.parse(
        localStorage.getItem("classStudentListFilter") as any
      );
    }
    this.getList();
  }
}
